import clsx from "clsx"
import { FormattedMessage } from "react-intl"

import { ListItem, P } from "@bullseye/components"

import { ActivityModal, useActivityModalContext } from "../../../../components"

export function CancelActivity({
  dismiss,
  disabled,
}: {
  dismiss: VoidFunction
  disabled: boolean
}) {
  const { openModal } = useActivityModalContext()
  return (
    <ListItem
      disabled={disabled}
      onPress={() => {
        dismiss()
        openModal(ActivityModal.CancelActivity)
      }}
      className={clsx({
        "bg-white": disabled,
      })}
    >
      <P className={clsx("text-gray-700", { "text-gray-100": !disabled })}>
        <FormattedMessage id="activity.manageActivity.cancelActivity" />
      </P>
    </ListItem>
  )
}
